// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body .sortablePlaceholder {
  --variant-height: 117px;
  position: relative;
  background-color: black;
}
.inline-group {
  display: flex;
  height: 40px;
  width: 100%;
}
.inline-group .inline-label {
  min-width: 90px;
  text-align: right;
  padding-right: 15px;
}
.fl-itm-c {
  align-items: center;
}
.fl-cnt-c {
  align-content: center;
}
.icon-btn {
  display: flex;
  align-items: center;
  font-size: 22px;
  line-height: 19px;
}
.btn-link {
  box-shadow: none !important;
}
.btn-link:hover {
  color: #000;
}
/*
.btn-minimal {
    color: #1fa9b0;
    box-shadow: none !important;
    background: none;

    &:hover {
        color: #000;
    }
}
*/
.input-invalid:after {
  content: '!';
  color: #fff;
  font-size: 11px;
  font-weight: 900;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -4px;
  left: -5px;
  height: 14px;
  width: 14px;
  background-color: red;
  border-radius: 50%;
}
segment-filter {
  position: relative;
  width: 100%;
}
.segment-builder {
  --sb-max-height: initial;
  --transition-duration: 0.2s;
  --transition-timing-function: ease;
  display: block;
  position: relative;
  height: auto;
  width: 100%;
  overflow: hidden;
}
.segment-builder .content-wrapper {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: auto;
  width: 100%;
}
.segment-builder:before {
  content: '';
  position: relative;
  display: block;
  height: 100%;
  height: var(--sb-max-height);
  width: 100%;
  transition: height 0.34s ease;
}
.segment-builder .segment-filter .segment-builder:before {
  transition-duration: 0s;
}
.segment-builder .segment-filter .list-unstyled {
  padding: 0;
}
.segment-builder .navbar-default,
.segment-builder #name,
.segment-builder #description,
.segment-builder .custom-scrollbar {
  background-color: #f8f8fa;
}
.segment-builder .segment-container {
  display: block;
  position: relative;
  padding: 10px 0;
  width: 100%;
}
.segment-builder .segment-container .list-unstyled {
  padding: 0;
}
.segment-builder .segment-container .conjunction {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 0;
  margin-left: 42px;
  bottom: 100%;
}
.segment-builder .segment-container .conjunction h5 {
  margin: 0 !important;
}
.segment-builder .segment-container .conjunction .badge {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 5px;
  background-color: #198a8f;
  border-radius: 2px;
  transition: opacity 0.08s ease;
  transition-property: transform, opacity;
  transition-delay: 0.2s;
  opacity: 1;
  user-select: none;
}
.segment-builder .segment-container .conjunction .badge h5 {
  font-weight: 600;
  font-size: 10px;
  color: white;
  text-transform: uppercase;
}
.segment-builder .segment-container.is-dragged .conjunction .badge {
  transform: scale(0.6);
  opacity: 0;
}
.segment-builder .segment-container .segment-set {
  display: grid;
  position: relative;
  grid-auto-flow: column;
  grid-template-columns: 24px auto 44px;
  margin: 0;
  padding: 0;
  border-radius: 4px;
  background-color: white;
  border: 1px solid #ddd;
}
.segment-builder .segment-container .segment-set.hide-right-tools {
  grid-template-columns: 24px auto 0;
}
.segment-builder .segment-container .segment-set.hide-right-tools > .right-tools {
  display: none;
}
.segment-builder .segment-container .drag-handle,
.segment-builder .segment-container .right-tools {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  grid-column: 1;
  height: 100%;
  width: 100%;
}
.segment-builder .segment-container .drag-handle {
  background-color: #198a8f08;
  border-radius: 4px 0 0 4px;
}
.segment-builder .segment-container .drag-handle .vector-icon {
  height: 100%;
}
.segment-builder .segment-container .drag-handle:hover {
  cursor: grab;
}
.segment-builder .segment-container .drag-handle:active {
  cursor: grabbing;
}
.segment-builder .segment-container .right-tools {
  display: flex;
  grid-column: 3;
  margin-left: auto;
  border-radius: 0 6px 6px 0;
}
.segment-builder .segment-container .right-tools .btn:hover .prime {
  fill: #a9638b;
}
.segment-builder .segment-container .segment-filter {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  grid-column: 2;
  padding: 4px 8px;
}
.segment-builder .segment-container .segment-filter .form-group {
  margin: 5px 4px;
}
.segment-builder .segment-container .segment-filter .form-group:not(.w-minmax-xxxl) {
  flex-grow: 1;
}
.segment-builder .segment-container .segment-filter .form-group + .form-group {
  padding-left: 0px;
}
.segment-builder .segment-container .segment-filter .form-control {
  height: 30px;
  padding: 4px 10px;
  font-size: 13px;
}
.segment-builder .segment-container .segment-filter .input-group-btn > .btn {
  height: 35px;
}
.segment-builder .segment-container .segment-filter .form-control-static {
  font-size: 13px;
  min-height: 0;
  padding: 10px 10px;
}
.segment-builder .segment-container .segment-filter .row :not(:first-child) {
  padding-left: 0;
}
.segment-builder .segment-container .segment-filter .row :not(:last-child) {
  padding-right: 5px;
}
.segment-builder .segment-container .segment-filter .select2-container {
  padding: 2px !important;
  min-height: 30px;
}
.segment-builder .segment-container .segment-filter .select2-container .select2-choices {
  gap: 2px;
}
.segment-builder .segment-container .segment-filter .select2-container .select2-choices .select2-search-choice {
  padding-top: 4px;
  padding-bottom: 4px;
}
.segment-builder .segment-container .segment-filter .select2-container .select2-choices .select2-search-choice .select2-search-choice-close {
  top: 4px;
}
.segment-builder .segment-container .segment-filter .mx-w-30rem {
  flex-grow: 1;
}
.segment-builder .segment-container .segment-filter .row {
  display: flex;
}
.segment-builder .segment-container .segment-filter .btn {
  padding: 4px 11px;
  font-size: 13px;
}
.sort-active .segment-container:nth-child(2) .conjunction .badge,
.ui-sortable-placeholder + .segment-container .conjunction .badge,
.ui-sortable-helper.segment-container + .segment-container .conjunction .badge,
.ui-sortable-helper.segment-container .conjunction .badge {
  transform: scale(0.6);
  opacity: 0;
  transition-delay: 0s;
}
.sort-active .ko_container.ui-sortable {
  overflow-y: hidden;
}
.autocomplete-dropdown {
  display: none;
  position: absolute;
  width: var(--ac-width);
  top: var(--ac-dropdown-top);
  left: var(--ac-dropdown-left);
  padding: 4px;
  border: 1px solid #1fa9b0;
  background-color: #fff;
  z-index: 4;
}
.autocomplete-dropdown.dis-bl {
  display: block;
}
.autocomplete-dropdown .autocomplete-option {
  padding: 4px 8px;
  user-select: none;
  cursor: pointer;
}
.autocomplete-dropdown .autocomplete-option.marked {
  color: #fff;
  background-color: #1fa9b0;
}
.working-indicator {
  display: block;
  position: absolute;
  height: 3px;
  width: var(--ac-width);
  border-radius: 1px;
  overflow: hidden;
  pointer-events: none;
}
.working-indicator.btm {
  bottom: 0;
}
.working-indicator.top {
  top: 0;
}
.working-indicator:before,
.working-indicator:after {
  content: '';
  display: block;
  position: absolute;
  height: 100%;
  width: 0px;
}
.working-indicator:before {
  background-color: #198a8f3b;
}
.working-indicator.active:before {
  animation: loading 0.6s linear infinite;
}
.working-indicator:after {
  background-color: #eb4a6f87;
}
.working-indicator.active:after {
  animation: loading2 0.4s linear infinite 0.1s;
}
@keyframes loading {
  0% {
    width: 0px;
    transform: translateX(-24px);
  }
  1% {
    width: 12px;
    transform: translateX(-24px);
  }
  25% {
    width: 60px;
    transform: translateX(calc(var(--ac-width) * 0.1));
  }
  60% {
    width: 100px;
    transform: translateX(calc(var(--ac-width) * 0.6));
  }
  99% {
    width: 120px;
    transform: translateX(calc(var(--ac-width) + 40px));
  }
  100% {
    width: 0px;
    transform: translateX(calc(var(--ac-width) + 120px));
  }
}
@keyframes loading2 {
  0% {
    width: 0px;
    transform: translateX(-66px);
  }
  1% {
    width: 44px;
    transform: translateX(-66px);
  }
  50% {
    width: 30px;
  }
  99% {
    width: 34px;
    transform: translateX(calc(var(--ac-width) + 24px));
  }
  100% {
    width: 0px;
    transform: translateX(calc(var(--ac-width) + 34px));
  }
}
`, "",{"version":3,"sources":["webpack://./Shared/SegmentFilter/SegmentFilter.less"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,kBAAA;EAEA,uBAAA;AAAJ;AAGA;EACI,aAAA;EACA,YAAA;EACA,WAAA;AADJ;AAGI;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;AADR;AAKA;EACI,mBAAA;AAHJ;AAMA;EACI,qBAAA;AAJJ;AAOA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AALJ;AAQA;EACI,2BAAA;AANJ;AAQI;EACI,WAAA;AANR;AACA;;;;;;;;;;CAUC;AAWD;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;AATJ;AAYA;EACI,kBAAA;EACA,WAAA;AAVJ;AAaA;EACI,wBAAA;EACA,2BAAA;EACA,kCAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AAXJ;AAaI;EACI,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AAXR;AAcI;EACI,WAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,4BAAA;EACA,WAAA;EACA,6BAAA;AAZR;AAdA;EA8BQ,uBAAA;AAbR;AAgBI;EACI,UAAA;AAdR;AApBA;;;;EAsCQ,yBAAA;AAZR;AA1BA;EA0CQ,cAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAbR;AAhCA;EAgDY,UAAA;AAbZ;AAnCA;EAoDY,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;AAdZ;AA5CA;EA6DgB,oBAAA;AAdhB;AA/CA;EAiEgB,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,8BAAA;EACA,uCAAA;EACA,sBAAA;EACA,UAAA;EACA,iBAAA;AAfhB;AA5DA;EA8EoB,gBAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;AAfpB;AAoBQ;EACI,qBAAA;EACA,UAAA;AAlBZ;AAtEA;EA4FY,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,qCAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;AAnBZ;AAqBY;EACI,kCAAA;AAnBhB;AAqBgB;EACI,aAAA;AAnBpB;AAvFA;;EAiHY,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;AAtBZ;AAjGA;EA2HY,2BAAA;EACA,0BAAA;AAvBZ;AArGA;EA+HgB,YAAA;AAvBhB;AA2BY;EACI,YAAA;AAzBhB;AA4BY;EACI,gBAAA;AA1BhB;AA9GA;EA6IY,aAAA;EACA,cAAA;EACA,iBAAA;EACA,0BAAA;AA5BZ;AApHA;EAmJgB,aAAA;AA5BhB;AAvHA;EAwJY,aAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AA9BZ;AA9HA;EA+JgB,eAAA;AA9BhB;AAgCgB;EACI,YAAA;AA9BpB;AApIA;EAuKgB,iBAAA;AAhChB;AAvIA;EA2KgB,YAAA;EACA,iBAAA;EACA,eAAA;AAjChB;AA5IA;EAiLgB,YAAA;AAlChB;AA/IA;EAqLgB,eAAA;EACA,aAAA;EACA,kBAAA;AAnChB;AApJA;EA2LgB,eAAA;AApChB;AAvJA;EA+LgB,kBAAA;AArChB;AA1JA;EAmMgB,uBAAA;EACA,gBAAA;AAtChB;AA9JA;EAuMoB,QAAA;AAtCpB;AAjKA;EA0MwB,gBAAA;EACA,mBAAA;AAtCxB;AArKA;EA8M4B,QAAA;AAtC5B;AAxKA;EAqNgB,YAAA;AA1ChB;AA3KA;EAyNgB,aAAA;AA3ChB;AA9KA;EA6NgB,iBAAA;EACA,eAAA;AA5ChB;AAkDA;;;;EAIG,qBAAA;EACA,UAAA;EACA,oBAAA;AAhDH;AAmDA;EACG,kBAAA;AAjDH;AAqDA;EACI,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,6BAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,UAAA;AAnDJ;AAqDI;EACI,cAAA;AAnDR;AAuCA;EAgBQ,gBAAA;EACA,iBAAA;EACA,eAAA;AApDR;AAsDQ;EACI,WAAA;EACA,yBAAA;AApDZ;AAyDA;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EAEA,gBAAA;EACA,oBAAA;AAxDJ;AA0DI;EACI,SAAA;AAxDR;AA2DI;EACI,MAAA;AAzDR;AA4DI;;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AAzDR;AA4DI;EACI,2BAAA;AA1DR;AA4DI;EACI,uCAAA;AA1DR;AA6DI;EACI,2BAAA;AA3DR;AA8DI;EACI,6CAAA;AA5DR;AAgEA;EACI;IACI,UAAA;IACA,4BAAA;EA9DN;EAgEE;IACI,WAAA;IACA,4BAAA;EA9DN;EAiEE;IACI,WAAA;IACA,kDAAA;EA/DN;EAkEE;IACI,YAAA;IACA,kDAAA;EAhEN;EAmEE;IACI,YAAA;IACA,mDAAA;EAjEN;EAmEE;IACI,UAAA;IACA,oDAAA;EAjEN;AACF;AAoEA;EACI;IACI,UAAA;IACA,4BAAA;EAlEN;EAoEE;IACI,WAAA;IACA,4BAAA;EAlEN;EAoEE;IACI,WAAA;EAlEN;EAoEE;IACI,WAAA;IACA,mDAAA;EAlEN;EAoEE;IACI,UAAA;IACA,mDAAA;EAlEN;AACF","sourcesContent":["body .sortablePlaceholder {\n    --variant-height: 117px;\n    position: relative;\n    //height: var(--variant-height);\n    background-color: black;\n}\n\n.inline-group {\n    display: flex;\n    height: 40px;\n    width: 100%;\n\n    & .inline-label {\n        min-width: 90px;\n        text-align: right;\n        padding-right: 15px;\n    }\n}\n\n.fl-itm-c {\n    align-items: center\n}\n\n.fl-cnt-c {\n    align-content: center\n}\n\n.icon-btn {\n    display: flex;\n    align-items: center;\n    font-size: 22px;\n    line-height: 19px;\n}\n\n.btn-link {\n    box-shadow: none !important;\n\n    &:hover {\n        color: #000;\n    }\n}\n\n/*\n.btn-minimal {\n    color: #1fa9b0;\n    box-shadow: none !important;\n    background: none;\n\n    &:hover {\n        color: #000;\n    }\n}\n*/\n\n.input-invalid:after {\n    content: '!';\n    color: #fff;\n    font-size: 11px;\n    font-weight: 900;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: -4px;\n    left: -5px;\n    height: 14px;\n    width: 14px;\n    background-color: red;\n    border-radius: 50%;\n}\n\nsegment-filter {\n    position: relative;\n    width: 100%;\n}\n\n.segment-builder {\n    --sb-max-height: initial;\n    --transition-duration: .2s;\n    --transition-timing-function: ease;\n    display: block;\n    position: relative;\n    height: auto;\n    width: 100%;\n    overflow: hidden;\n\n    & .content-wrapper {\n        display: block;\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: auto;\n        width: 100%;\n    }\n\n    &:before {\n        content: '';\n        position: relative;\n        display: block;\n        height: 100%;\n        height: var(--sb-max-height);\n        width: 100%;\n        transition: height .34s ease;\n    }\n\n    .segment-filter .segment-builder:before {\n        transition-duration: 0s;\n    }\n\n    & .segment-filter .list-unstyled {\n        padding: 0;\n    }\n\n    .navbar-default, #name, #description, .custom-scrollbar {\n        background-color: #f8f8fa;\n    }\n\n    .segment-container {\n        display: block;\n        position: relative;\n        padding: 10px 0;\n        width: 100%;\n\n        .list-unstyled {\n            padding: 0;\n        }\n\n        .conjunction {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            position: absolute;\n            height: 0;\n            margin-left: 42px;\n            bottom: 100%;\n\n            h5 {\n                margin: 0 !important;\n            }\n\n            .badge {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                padding: 0 5px;\n                background-color: #198a8f;\n                border-radius: 2px;\n                transition: opacity .08s ease;\n                transition-property: transform, opacity;\n                transition-delay: .2s;\n                opacity: 1;\n                user-select: none;\n\n                h5 {\n                    font-weight: 600;\n                    font-size: 10px;\n                    color: white;\n                    text-transform: uppercase;\n                }\n            }\n        }\n\n        &.is-dragged .conjunction .badge {\n            transform: scale(.6);\n            opacity: 0;\n        }\n\n        .segment-set {\n            display: grid;\n            position: relative;\n            grid-auto-flow: column;\n            grid-template-columns: 24px auto 44px;\n            margin: 0;\n            padding: 0;\n            border-radius: 4px;\n            background-color: white;\n            border: 1px solid #ddd;\n\n            &.hide-right-tools {\n                grid-template-columns: 24px auto 0;\n\n                & > .right-tools {\n                    display: none;\n                }\n            }\n        }\n\n        .drag-handle,\n        .right-tools {\n            display: flex;\n            position: relative;\n            justify-content: center;\n            align-items: center;\n            grid-column: 1;\n            height: 100%;\n            width: 100%;\n        }\n\n        .drag-handle {\n            background-color: #198a8f08;\n            border-radius: 4px 0 0 4px;\n\n            .vector-icon {\n                height: 100%;\n                //width: 100%;\n            }\n\n            &:hover {\n                cursor: grab;\n            }\n\n            &:active {\n                cursor: grabbing;\n            }\n        }\n\n        .right-tools {\n            display: flex;\n            grid-column: 3;\n            margin-left: auto;\n            border-radius: 0 6px 6px 0;\n\n            .btn:hover .prime {\n                fill: #a9638b;\n            }\n        }\n\n        .segment-filter {\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n            grid-column: 2;\n            padding: 4px 8px;\n\n            .form-group {\n                margin: 5px 4px;\n\n                &:not(.w-minmax-xxxl) {\n                    flex-grow: 1;\n                }\n            }\n\n            .form-group + .form-group {\n                padding-left: 0px;\n            }\n\n            .form-control {\n                height: 30px;\n                padding: 4px 10px;\n                font-size: 13px;\n            }\n\n            .input-group-btn > .btn {\n                height: 35px;\n            }\n\n            .form-control-static {\n                font-size: 13px;\n                min-height: 0;\n                padding: 10px 10px;\n            }\n\n            .row :not(:first-child) {\n                padding-left: 0;\n            }\n\n            .row :not(:last-child) {\n                padding-right: 5px;\n            }\n\n            .select2-container {\n                padding: 2px !important;\n                min-height: 30px;\n\n                .select2-choices {\n                    gap: 2px;\n\n                    .select2-search-choice {\n                        padding-top: 4px;\n                        padding-bottom: 4px;\n\n                        .select2-search-choice-close {\n                            top: 4px;\n                        }\n                    }\n                }\n            }\n\n            .mx-w-30rem {\n                flex-grow: 1;\n            }\n\n            .row {\n                display: flex;\n            }\n\n            .btn {\n                padding: 4px 11px;\n                font-size: 13px;\n            }\n        }\n    }\n}\n\n.sort-active .segment-container:nth-child(2) .conjunction .badge,\n.ui-sortable-placeholder + .segment-container .conjunction .badge,\n.ui-sortable-helper.segment-container + .segment-container .conjunction .badge,\n.ui-sortable-helper.segment-container .conjunction .badge {\n   transform: scale(.6);\n   opacity: 0;\n   transition-delay: 0s;\n}\n\n.sort-active .ko_container.ui-sortable {\n   overflow-y: hidden;\n}\n\n//autocomplete component, move this\n.autocomplete-dropdown {\n    display: none;\n    position: absolute;\n    width: var(--ac-width);\n    top: var(--ac-dropdown-top);\n    left: var(--ac-dropdown-left);\n    padding: 4px;\n    border: 1px solid #1fa9b0;\n    background-color: #fff;\n    z-index: 4;\n\n    &.dis-bl {\n        display: block;\n    }\n\n    .autocomplete-option {\n        padding: 4px 8px;\n        user-select: none;\n        cursor: pointer;\n\n        &.marked {\n            color: #fff;\n            background-color: #1fa9b0;\n        }\n    }\n}\n\n.working-indicator {\n    display: block;\n    position: absolute;\n    height: 3px;\n    width: var(--ac-width);\n    border-radius: 1px;\n\n    overflow: hidden;\n    pointer-events: none;\n\n    &.btm {\n        bottom: 0;\n    }\n\n    &.top {\n        top: 0;\n    }\n\n    &:before, &:after {\n        content: '';\n        display: block;\n        position: absolute;\n        height: 100%;\n        width: 0px;\n    }\n\n    &:before {\n        background-color: #198a8f3b;\n    }\n    &.active:before {\n        animation: loading .6s linear infinite;\n    }\n\n    &:after {\n        background-color: #eb4a6f87;\n        \n    }\n    &.active:after {\n        animation: loading2 .4s linear infinite .1s;\n    }\n}\n\n@keyframes loading {\n    0% {\n        width: 0px;\n        transform: translateX(-24px);\n    }\n    1% {\n        width: 12px;\n        transform: translateX(-24px);\n    }\n\n    25% {\n        width: 60px;\n        transform: translateX(calc(var(--ac-width) * .1 ));\n    }\n\n    60% {\n        width: 100px;\n        transform: translateX(calc(var(--ac-width) * .6 ));\n    }\n\n    99% {\n        width: 120px;\n        transform: translateX(calc(var(--ac-width) + 40px ));\n    }\n    100% {\n        width: 0px;\n        transform: translateX(calc(var(--ac-width) + 120px ));\n    }\n}\n\n@keyframes loading2 {\n    0% {\n        width: 0px;\n        transform: translateX(-66px);\n    }\n    1% {\n        width: 44px;\n        transform: translateX(-66px);\n    }\n    50% {\n        width: 30px;\n    }\n    99% {\n        width: 34px;\n        transform: translateX(calc(var(--ac-width) + 24px ));\n    }\n    100% {\n        width: 0px;\n        transform: translateX(calc(var(--ac-width) + 34px ));\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
